import React from "react";
import { useTranslation } from "react-i18next";
import { WizardStepProps } from "@components/WizardCst/types";
import ToggleSection from "../../MainInfoStep/sections/ToggleSection";

interface HighlightsSectionData {
  highlight_explore: boolean;
}

function HighlightsSection<T extends HighlightsSectionData>({
  data,
  setData,
}: WizardStepProps<T>): React.ReactElement {
  const { t } = useTranslation("wizard-activity");
  return (
    <ToggleSection
      question={t("editorial.highlights.question")}
      description={t("editorial.highlights.description") || undefined}
      checked={data.highlight_explore}
      onChange={(next) => setData({ highlight_explore: next } as Partial<T>)}
      noLabel={t("common.no") || "No"}
      yesLabel={t("common.yes") || "Sì"}
    />
  );
}

export default HighlightsSection;
